import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import NewCompany from '../../components/drawers/newCompany'

const Companies = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')

    const [newCompanyModal, toggleNewCompanyModal] = useToggle()
    const [companyModal, toggleCompanyModal] = useToggle()

    const select = comp => {
        setSelected(comp)
        toggleCompanyModal()
    }
    
    const [
        { loading, error, fetch }, 
        { list: companies }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('companies', { string }, { notify: true, manual: false })

    const search = str => {
        setString(str)
        navigate(1)
        fetch()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Account has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        fetch()
    }

    const [, execute] = usePet('toggleActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = ins => {
        setSelected(ins)
        execute()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newCompanyModal &&
                <NewCompany
                    company={ selected }
                    onPerform={ fetch }
                    toggle={ selected?._id ? toggleCompanyModal : toggleNewCompanyModal }
                    visible={ newCompanyModal } />
            }
            {
                companyModal &&
                <NewCompany
                    company={ selected }
                    onPerform={ fetch }
                    toggle={ toggleCompanyModal }
                    visible={ companyModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewCompanyModal } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add New Company</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">Companies</h2>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                companies.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Phone</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                companies.map((company, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ company.name }</div>
                                                            {
                                                                company?.shaEnabled &&
                                                                <div className="flex flex-wrap gap-2 mt-1">
                                                                    <span className="inline-flex font-medium rounded-full text-center px-2.5 py-0.5 text-xs bg-green-100 text-green-600">
                                                                        Kenya SHA enabled
                                                                    </span>
                                                                    {
                                                                        company?.shaBiometricEnabled &&
                                                                        <span className="inline-flex font-medium rounded-full text-center px-2.5 py-0.5 text-xs bg-emerald-100 text-emerald-700">
                                                                            Biometric enabled
                                                                        </span>
                                                                    }
                                                                    {
                                                                        company?.shaFacilityFrCode &&
                                                                        <span className="inline-flex font-medium rounded-full text-center px-2.5 py-0.5 text-xs bg-blue-100 text-blue-700">
                                                                            FR code set
                                                                        </span>
                                                                    }
                                                                </div>
                                                            }
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ company.phone }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(company.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(company) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(company) }>{ company.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new company</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Companies
